import { Component, OnInit } from '@angular/core';
import { UserService, MessagesServices } from '../../../api';
import { ActivatedRoute } from '@angular/router';
import { ConfirmDialogComponent } from '../../../';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ToastyService, ToastOptions } from 'ng2-toasty';

@Component({
  selector: 'app-package-detail',
  templateUrl: './package-detail.component.html',
  styleUrls: ['./package-detail.component.css']
})
export class PackageDetailComponent implements OnInit {
  private package: any = null;
  private loading: boolean = true;
  public soundsChartLabels: string[] = ['Sounds Used', 'Sounds Available'];
  public soundsChartData: number[] = [];
  public songsChartLabels: string[] = ['Songs Used', 'Songs Available'];
  public songsChartData: number[] = [];
  public pieChartType: string = 'pie';
  public options = {
    legend: { labels: { fontColor: "white", fontSize: 12 } }
  };
  dialogRef: MdDialogRef<ConfirmDialogComponent>;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';

  constructor(private userService: UserService, private sm: MessagesServices, private route: ActivatedRoute, public dialog: MdDialog,
  public toastyService: ToastyService) {
    //getting messages from db
    this.messages = this.sm.messags;
    this.setMessages();
  }

  /**
   * setting system messages
   **/
  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_SUBSCRIPTION_CANCELLED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_SUBSCRIPTION_CANNOT_BE_CANCELLED') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_SUBSCRIPTION') {
          this.msg3 = this.messages[i].message;
        }
      }
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.userService.getActivePackageDetail(params['id']).subscribe((res) => {
        this.package = res;
        this.soundsChartData.push(this.package.sounds - this.package.soundsLeft);
        this.soundsChartData.push(this.package.soundsLeft);
        this.songsChartData.push(this.package.songs - this.package.songsLeft);
        this.songsChartData.push(this.package.songsLeft);
        this.loading = false;
      });
    });
  }

  cancelSubscription() {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false,
    });
    this.dialogRef.componentInstance.message = this.msg3;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result && result === true) {
        this.userService.cancelSubscription(this.package.id).subscribe((res) => {
          if (res && res.status === 'success') {
            this.handleResponse(res.status);
            this.package.paymentDetail.status = 'Cancelled';
          } else {
            this.handleResponse(res.status);
          }
        }, (err) => {
          this.handleResponse('error');
        });
      }
    });
  }

  handleResponse(response) {
    if (response === 'success') {
      let toastOptions: ToastOptions = {
        title: this.title1,
        msg: this.msg1,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.success(toastOptions);
    } else {
      let toastOptions: ToastOptions = {
        title: this.title2,
        msg: this.msg2,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.error(toastOptions);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/user/my-package/package-detail/package-detail.component.ts